export default __webpack_public_path__ + "media/images/mailer/icon_lock_open-25c0560a8a5fb6604643f4b41e15efb8.png";